<div class="container">
  <div class="row">
    <div class="col-sm-12">
      <app-sobre-nosotros></app-sobre-nosotros>
    </div>
    <div class="col-sm-12">
      <app-holding-epysa></app-holding-epysa>
    </div>
    <div class="col-sm-12 lg:block">
      <app-mi-cuenta></app-mi-cuenta>
    </div>
    <div class="col-sm-12">
      <app-contactanos></app-contactanos>
    </div>
    <div class="col-sm-12 text-center mb-1">
      <div class="row">
        <div class="col-6 text-center mb-1">
          <div>
            <picture
              style="width: 50px; aspect-ratio: 42/61; position: relative"
            >
              <source
                srcset="assets/images/mutual_01.webp"
                type="image/webp"
              />
              <source srcset="assets/images/mutual_01.png" type="image/png" />
              <img ngSrc="assets/images/mutual_01.png" alt="mutual" fill />
            </picture>
          </div>
        </div>
        <div class="col-6 text-center mb-1">
          <h4 class="fw-bold text-center">Síguenos</h4>

          <a
            class="me-1"
            [href]="config.company.facebook"
            rel="noopener"
            target="_blank"
          >
            <img
              src="../../../../../assets/svg/17.svg"
              style="width: 40px; height: 40px"
              alt="facebook"
            />
          </a>
          <a
            class="me-2"
            [href]="config.company.instagram"
            target="_blank"
            rel="noopener"
          >
            <img
              src="../../../../../assets/svg/18.svg"
              style="width: 40px; height: 40px"
              alt="instagram"
            />
          </a>
          <a [href]="config.company.linkedin" target="_blank" rel="noopener">
            <img
              src="../../../../../assets/svg/19.svg"
              style="width: 40px; height: 40px"
              alt="linkedin"
            />
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-12 fw-bold" style="font-size: 0.8rem">
      Implementos es la red de repuestos, suministros y accesorios para
      camiones, autobuses y remolques más grande del país.
    </div>
  </div>
</div>

<div style="height: 30px; background-color: #000"></div>
